import { Router } from "@solidjs/router";
import { AuthProvider } from "./features/auth/AuthProvider";
import { routes } from "./routes";

export function App() {
  return (
    <AuthProvider>
      <Router>{routes}</Router>
    </AuthProvider>
  );
}
